import { render } from "./VSATTemplate.vue?vue&type=template&id=460d1989&scoped=true"
import script from "./VSATTemplate.vue?vue&type=script&lang=js"
export * from "./VSATTemplate.vue?vue&type=script&lang=js"

import "./VSATTemplate.vue?vue&type=style&index=0&id=460d1989&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460d1989"]])

export default __exports__